"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileSize = fileSize;
exports.megabitRate = megabitRate;

var _I18n = _interopRequireDefault(require("I18n"));

var UNITS_FOR_POWERS_OF_KILO = {
  GB: Math.pow(2, 30),
  MB: Math.pow(2, 20)
};
var megabitToBit = 0.000001;

function fileSize(filesize) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  for (var unit in UNITS_FOR_POWERS_OF_KILO) {
    if (Object.prototype.hasOwnProperty.call(UNITS_FOR_POWERS_OF_KILO, unit)) {
      var minnum = UNITS_FOR_POWERS_OF_KILO[unit];

      if (filesize >= minnum) {
        return _I18n.default.formatNumber(filesize / minnum, {
          precision: precision
        }) + " " + unit;
      }
    }
  }

  if (filesize >= 1024) {
    return _I18n.default.formatNumber(filesize / 1024, {
      precision: 0
    }) + " KB";
  }

  return _I18n.default.formatNumber(filesize) + " B";
}

function megabitRate(bitrate) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var mbRate = bitrate * megabitToBit;
  return _I18n.default.formatNumber(mbRate, {
    precision: precision
  }) + " Mb/s";
}